<template>
  <div class="nominations-section mt-4 border-top pt-4">
    <div v-if="event != null" class="d-flex flex-wrap align-items-center mb-3">
      <span class="mr-3 mb-2 nominations-section__event-name">{{ event.name }} nominations</span>
    </div>
    <div v-if="isLocked" class="text-muted font-italic py-3 text-center">
      This event is locked, unlock the event to edit it.
    </div>
    <template v-else>
    <bulk-editor-tool

      :total-count="filteredNominations.length"
      :selected-count="selectedGroupUserIds.length"
      @toggle-all="toggleSelectAll"
    >
      <div v-if="activeList === 'accept'" class="bulk-action-group mr-3">
        <label class="bulk-action-group__label">Payment status</label>
        <div class="d-flex align-items-center">
          <app-multiselect
            :value="bulkPaymentStatus"
            :options="paymentStatusOptions"
            label="label"
            track-by="value"
            :searchable="false"
            :allow-empty="true"
            placeholder="-"
            select-label=""
            deselect-label=""
            selected-label=""
            class="bulk-action-group__select mr-2"
            @input="bulkPaymentStatus = $event"
          />
          <app-button
            type="button"
            variant="outline-primary"
            :block="false"
            :loading="applyingBulkPayment"
            :disabled="selectedGroupUserIds.length === 0 || bulkPaymentStatus == null || applyingBulkPayment"
            @click="applyBulkPaymentStatus"
          >
            Apply
          </app-button>
        </div>
      </div>
      <div class="bulk-action-group mr-3">
        <label class="bulk-action-group__label">Nomination status</label>
        <div class="d-flex align-items-center">
          <app-multiselect
            :value="bulkList"
            :options="moveableLists"
            label="label"
            track-by="value"
            :searchable="false"
            :allow-empty="true"
            placeholder="-"
            select-label=""
            deselect-label=""
            selected-label=""
            class="bulk-action-group__select mr-2"
            @input="bulkList = $event"
          />
          <app-button
            type="button"
            variant="outline-primary"
            :block="false"
            :loading="applyingBulk"
            :disabled="selectedGroupUserIds.length === 0 || bulkList == null || applyingBulk"
            @click="applyBulkStatus"
          >
            Apply
          </app-button>
        </div>
      </div>
      <div v-if="activeList === 'accept'" class="bulk-action-group">
        <label class="bulk-action-group__label">Payment type</label>
        <div class="d-flex align-items-center">
          <app-multiselect
            :value="bulkComment"
            :options="commitOptions"
            label="label"
            track-by="value"
            :searchable="false"
            :allow-empty="true"
            placeholder="-"
            select-label=""
            deselect-label=""
            selected-label=""
            class="bulk-action-group__select mr-2"
            @input="bulkComment = $event"
          />
          <app-button
            type="button"
            variant="outline-primary"
            :block="false"
            :loading="applyingBulkComment"
            :disabled="selectedGroupUserIds.length === 0 || bulkComment == null || applyingBulkComment"
            @click="applyBulkComment"
          >
            Apply
          </app-button>
        </div>
      </div>
    </bulk-editor-tool>
    <tab-search-bar
      :items="listTabItems"
      :active-tab="activeList"
      :search="searchInput"
      placeholder="Name or member number"
      @tab-change="onListChange"
      @search-input="$emit('search-input', $event)"
    />
    <div class="action-buttons d-flex justify-content-between w-100 mt-3 mb-3">
      <div class="action-buttons__left">
        <div>
          <router-link :to="`/nominations/${draftId}/reassign-member`" class="m-0 btn btn-block-mob btn-outline-primary">Re-assign nominations</router-link>
        </div>
        <div class="mt-2">
          <router-link :to="`/nominations/${draftId}/bulk-email`" class="m-0 btn btn-block-mob btn-outline-primary">Send bulk email/text</router-link>
        </div>
        <div v-if="drawIsPublished" class="mt-2">
          <app-button type="button" variant="outline-primary" :block="false" class="m-0 btn-block-mob" @click="showResendModal = true">Re-send draws notifications</app-button>
        </div>
        <div v-if="activeList === 'accept'" class="mt-2">
          <app-button type="button" variant="primary" :block="false" class="m-0 btn-block-mob" :loading="sendingReminders" @click="sendOverdueReminders">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right:8px;vertical-align:middle;position:relative;top:2px"><path d="M17.7158 9.37948V2.22974C17.7158 1.91365 17.4561 1.65869 17.1448 1.65869H1.07929C0.766467 1.65869 0.50824 1.91494 0.50824 2.22974V12.5086C0.50824 12.824 0.763917 13.0796 1.07929 13.0796H9.75304C9.73222 13.2672 9.72114 13.4577 9.72114 13.6507C9.72114 16.4846 12.0267 18.7901 14.8606 18.7901C17.6944 18.7901 20 16.4846 20 13.6507C20 11.8725 19.0922 10.3026 17.7158 9.37948ZM15.3628 2.80079L9.14853 7.23958L2.87504 2.80079H15.3628ZM1.65033 11.9375V3.33331L8.82026 8.40638C8.91908 8.47631 9.03459 8.51126 9.15009 8.51126C9.26643 8.51126 9.38274 8.47578 9.48202 8.40489L16.5737 3.3394V8.80524C16.0376 8.61512 15.461 8.51126 14.8606 8.51126C12.6271 8.51126 10.7222 9.94345 10.0151 11.9375H1.65033ZM14.8606 17.648C12.6564 17.648 10.8632 15.8548 10.8632 13.6507C10.8632 11.4466 12.6564 9.65336 14.8606 9.65336C17.0647 9.65336 18.8579 11.4466 18.8579 13.6507C18.8579 15.8548 17.0647 17.648 14.8606 17.648Z" fill="white"/><path d="M17.9045 12.8131C17.7629 12.6536 17.5157 12.6363 17.3524 12.7744L17.0739 13.0097C16.8399 11.8652 15.8023 11 14.5612 11C13.149 11 12 12.1212 12 13.4995C12 14.8783 13.149 16 14.5612 16C15.0657 16 15.5528 15.8575 15.9699 15.5879C16.1501 15.4714 16.1995 15.2344 16.0801 15.0586C15.9607 14.8827 15.7178 14.8346 15.5377 14.9511C15.2491 15.1376 14.9115 15.2361 14.5612 15.2361C13.5806 15.2361 12.7828 14.4571 12.7828 13.4995C12.7828 12.5425 13.5806 11.7639 14.5612 11.7639C15.3765 11.7639 16.0651 12.3016 16.2748 13.0324L15.9862 12.8214C15.8131 12.6949 15.5679 12.7292 15.4383 12.8981C15.3087 13.0669 15.3439 13.3063 15.5169 13.4328L16.472 14.1311C16.5417 14.182 16.6243 14.2073 16.7066 14.2073C16.7982 14.2073 16.8896 14.176 16.9629 14.1141L17.8648 13.352C18.0282 13.2138 18.046 12.9726 17.9045 12.8131Z" fill="white"/></svg>
            <small>SEND PAYMENT REMINDER</small>
          </app-button>
        </div>
        <div v-if="eventMembersAllowed" class="mt-2">
          <router-link :to="`/draft-members/${draftId}`" class="m-0 btn btn-block-mob btn-primary">Show Event Members in Draft</router-link>
        </div>
      </div>
      <div class="action-buttons__right">
        <div class="d-flex justify-content-end w-100 flex-column mb-4">
          <div class="d-flex h5 mr-5 justify-content-end">Biosecurity Form Report</div>
          <div class="d-flex flex-wrap justify-content-end">
            <app-button type="button" variant="primary" size="sm" :block="false" class="ml-3" :loading="downloadingBiosecurityPdf" @click="downloadBiosecurityReport('pdf')">Download PDF</app-button>
            <app-button type="button" variant="primary" size="sm" :block="false" class="ml-3" :loading="downloadingBiosecurityCsv" @click="downloadBiosecurityReport('csv')">Download CSV</app-button>
          </div>
        </div>
        <div class="d-flex justify-content-end w-100 flex-column">
          <div class="d-flex h5 mr-5 justify-content-end">Vehicle Information Report</div>
          <div class="d-flex flex-wrap justify-content-end">
            <app-button type="button" variant="primary" size="sm" :block="false" class="ml-3" :loading="downloadingVehiclesPdf" @click="downloadVehiclesReport()">Download PDF</app-button>
          </div>
        </div>
      </div>
    </div>
    <f-radio-group
      v-if="activeList === 'accept'"
      name="paymentStatusFilter"
      label="Payment status filter"
      :value="paymentFilter"
      :options="paymentFilterOptions"
      inline
      @input="paymentFilter = $event"
    />
    <form-alert :message="bulkAlert.message.value" :type="bulkAlert.type.value" class="mt-2" />

    <div v-if="blockedAccept.length" class="alert alert-warning mt-2 blocked-accept" role="alert">
      <button
        type="button"
        class="close blocked-accept__close"
        aria-label="Dismiss"
        @click="dismissBlockedAccept"
      >&times;</button>
      <p class="mb-2 font-weight-bold">
        These competitors are already accepted into an overlapping draft. Move them to another list, then accept the rest:
      </p>
      <ul class="blocked-accept__list list-unstyled mb-0">
        <li v-for="c in blockedAccept" :key="c.id" class="blocked-accept__row">
          <button
            type="button"
            class="blocked-accept__search"
            title="Search for this competitor"
            @click="searchBlocked(c)"
          >
            <svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true" focusable="false">
              <path
                fill="currentColor"
                d="M15.5 14h-.79l-.28-.27a6.5 6.5 0 1 0-.7.7l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0A4.5 4.5 0 1 1 14 9.5 4.5 4.5 0 0 1 9.5 14z"
              />
            </svg>
          </button>
          <span class="blocked-accept__name">
            {{ c.name }}<span v-if="c.deleted" class="text-muted"> (deleted)</span><template v-if="c.draft"> — accepted in “{{ c.draft }}”</template>
          </span>
        </li>
      </ul>
    </div>

    <nominations-dashboard-table
      :nominations="filteredNominations"
      :loading="loadingNominations"
      :draft-id="draftId"
      :move-group="handleMoveGroup"
      :commit-options="commitOptions"
      :payment-status-options="paymentStatusOptions"
      :error-key="tableErrorKey"
      :selectable="true"
      :selected-ids="selectedGroupUserIds"
      :active-list="activeList"
      :event-mode="event != null"
      @toggle-select="toggleSelect"
      @open-detail="onOpenDetail"
      @commit-change="onRowCommitChange"
      @payment-status-change="onRowPaymentStatusChange"
      @open-partial-payment="onOpenPartialPayment"
    >
      <template #before-row="{ row }">
        <row-alert
          v-if="rowAlert.alert.value.message && rowAlert.alert.value.rowId === row.user.id"
          :message="rowAlert.alert.value.message"
          :type="rowAlert.alert.value.type"
          :alert-key="rowAlert.alert.value.id"
          @dismiss="rowAlert.clear()"
        />
      </template>
    </nominations-dashboard-table>

    <committee-partial-payment-popup
      v-if="partialPaymentTarget != null"
      :draft-id="draftId"
      :user-id="partialPaymentTarget.userId"
      :payment-type="partialPaymentTarget.paymentType"
      :on-changed="markPartialPaymentChanged"
      @success="onPartialPaymentSuccess"
      @close="closePartialPayment"
    />

    <nomination-account-detail-popup
      v-if="detailTarget != null"
      :draft-id="draftId"
      :user-id="detailTarget.userId"
      :list="detailTarget.list"
      :event-id="detailTarget.eventId"
      :draft-state-id="draftStateId"
      :draw-exists="drawExists"
      :on-changed="markDetailChanged"
      @close="closeDetail"
    />

    <confirm-modal
      v-if="pendingMove != null"
      @confirm="confirmPendingMove"
      @cancel="pendingMove = null"
    >
      <template v-if="pendingMove.warning === 'draw'">
        <p>{{ closedDrawWarning }}</p>
        <p>To do this go to the <router-link :to="{ name: 'DrawsDashboard' }">Draws page</router-link>.</p>
        <p class="mb-0">Proceed anyway?</p>
      </template>
      <p v-else class="mb-0">{{ acceptInvoiceWarning }}</p>
    </confirm-modal>

    <!-- Re-send draws notifications: select events (none checked = resend to every event in the draft) -->
    <modal v-if="showResendModal" @close="showResendModal = false">
      <div slot="body">
        <p class="font-weight-bold mb-2">Select events</p>
        <p class="text-muted small mb-3">Leave all unchecked to resend to every event in the draft.</p>
        <div v-for="ev in events" :key="ev.id" class="form-check mb-1">
          <input
            :id="`resend-event-${ev.id}`"
            v-model="resendEventIds"
            type="checkbox"
            class="form-check-input"
            :value="ev.id"
          >
          <label class="form-check-label" :for="`resend-event-${ev.id}`">{{ ev.name }}</label>
        </div>
      </div>
      <div slot="footer">
        <div class="d-flex justify-content-center">
          <app-button type="button" variant="primary" :block="false" :loading="sendingResend" @click="submitResend">Send</app-button>
          <button class="btn btn-outline-primary ml-2" @click="showResendModal = false">Cancel</button>
        </div>
      </div>
    </modal>
    </template>
  </div>
</template>

<script>
import { defineComponent, ref, computed, watch } from '@vue/composition-api'
import TabSearchBar from '@/components/TabSearchBar'
import AppButton from '@/components/AppButton'
import AppMultiselect from '@/components/AppMultiselect'
import BulkEditorTool from '@/components/BulkEditorTool'
import FormAlert from '@/components/FormAlert'
import RowAlert from '@/components/RowAlert'
import useRowAlert from '@/composables/useRowAlert'
import FRadioGroup from '@/components/FormFields/FRadioGroup'
import ConfirmModal from '@/components/ConfirmModal'
import Modal from '@/components/Modal'
import NominationsDashboardTable from '@/views/Nominations/components/NominationsDashboardTable'
import NominationAccountDetailPopup from '@/views/Nominations/components/NominationAccountDetailPopup'
import useNominationLists from '@/composables/nominations/useNominationLists'
import useFormAlert from '@/composables/useFormAlert'
import nominationsApi from '@/services/api/nominations'
import invoicesApi from '@/services/api/invoices'
import biosecurityApi from '@/services/api/biosecurity'
import reportsApi from '@/services/api/reports'
import drawsApi from '@/services/api/draws'
import { ACCEPT_INVOICE_WARNING, CLOSED_DRAW_WARNING, moveWarningType } from '@/utils/nominationMove'
import CommitteePartialPaymentPopup from './CommitteePartialPaymentPopup'

export default defineComponent({
  name: 'CommitteeDashboardNominations',
  components: { TabSearchBar, AppButton, AppMultiselect, BulkEditorTool, NominationsDashboardTable, NominationAccountDetailPopup, CommitteePartialPaymentPopup, FormAlert, RowAlert, FRadioGroup, ConfirmModal, Modal },
  props: {
    draftId: { type: Number, required: true },
    draftStateId: { type: Number, default: null },
    nominations: { type: Array, default: () => [] },
    loadingNominations: { type: Boolean, default: false },
    listTabItems: { type: Array, default: () => [] },
    activeList: { type: String, default: null },
    searchInput: { type: String, default: '' },
    drawIsPublished: { type: Boolean, default: false },
    eventMembersAllowed: { type: Boolean, default: false },
    event: { type: Object, default: null },
    events: { type: Array, default: () => [] }
  },
  emits: ['list-change', 'search-input', 'reload'],
  setup(props, { emit }) {
    const { listItems } = useNominationLists()
    const moveableLists = computed(() => listItems.value.filter(l => l.value !== 'scratchedByUser'))
    const isLocked = computed(() => props.event != null && !!props.event.is_locked)

    const tableErrorKey = ref(0)

    const partialPaymentTarget = ref(null)
    const partialPaymentHasChanges = ref(false)

    function onOpenPartialPayment(row) {
      const commits = row.nominations.map(n => n.commit).filter(commit => commit != null)
      const uniqueCommits = commits.filter((commit, index) => commits.indexOf(commit) === index)

      partialPaymentHasChanges.value = false
      partialPaymentTarget.value = {
        userId: row.user.id,
        paymentType: uniqueCommits.length === 1 ? uniqueCommits[0] : null
      }
    }

    function closePartialPayment() {
      partialPaymentTarget.value = null
      tableErrorKey.value++
    }

    function markPartialPaymentChanged() {
      partialPaymentHasChanges.value = true
    }

    watch(() => partialPaymentTarget.value, (val, prev) => {
      if (prev != null && val == null && partialPaymentHasChanges.value) emit('reload')
    })

    const detailTarget = ref(null)
    const detailHasChanges = ref(false)

    function onOpenDetail(row) {
      detailHasChanges.value = false
      detailTarget.value = {
        userId: row.user.id,
        list: props.activeList,
        eventId: props.event != null ? props.event.id : null
      }
    }

    function closeDetail() {
      detailTarget.value = null
    }

    function markDetailChanged() {
      detailHasChanges.value = true
    }

    watch(() => detailTarget.value, (val, prev) => {
      if (prev != null && val == null && detailHasChanges.value) emit('reload')
    })

    const commitOptions = ref([])
    nominationsApi.getCommits().then((res) => { commitOptions.value = res.data.data })

    const paymentStatusOptions = ref([])
    nominationsApi.getPaymentStatuses().then((res) => {
      paymentStatusOptions.value = res.data.data
    })

    // Monolith parity: accept tab filters rows client-side by fully-paid status.
    const paymentFilterOptions = [
      { value: 'all', label: 'all' },
      { value: 'paid', label: 'paid' },
      { value: 'unpaid', label: 'unpaid' }
    ]
    const paymentFilter = ref('all')

    const filteredNominations = computed(() => {
      if (props.activeList !== 'accept' || paymentFilter.value === 'all') return props.nominations
      const wantPaid = paymentFilter.value === 'paid'
      return props.nominations.filter((g) => {
        const fullyPaid = g.nominations.length > 0 && g.nominations.every(n => n.is_paid)
        return wantPaid ? fullyPaid : !fullyPaid
      })
    })

    const bulkAlert = useFormAlert()
    // Results of actions on one nomination row appear right above that row (not above the table);
    // bulk actions, which are not tied to one row, keep using bulkAlert.
    const rowAlert = useRowAlert()
    // A moved row leaves the current list once the list reloads, so its message goes above the row
    // that takes its place (the next one, or the previous when it was the last).
    function neighbourUserId(userId) {
      const list = filteredNominations.value
      const index = list.findIndex(g => g.user.id === userId)
      if (index === -1) return null
      const neighbour = list[index + 1] || list[index - 1]
      return neighbour != null ? neighbour.user.id : null
    }
    function notifyRow(rowUserId, message, type, options) {
      if (rowUserId == null) {
        if (type === 'success') bulkAlert.showSuccess(message)
        else if (options && options.persistent) bulkAlert.showPersistentError(message)
        else bulkAlert.showError(message)
        return
      }
      bulkAlert.clear()
      rowAlert.show(message, type, rowUserId, options)
    }
    function onPartialPaymentSuccess(message) {
      notifyRow(partialPaymentTarget.value != null ? partialPaymentTarget.value.userId : null, message != null ? message : 'Success', 'success')
    }
    // Competitors that block a move-to-accept because they are already accepted into an
    // overlapping draft (structured payload from the API's `overlapping_accept` error).
    const blockedAccept = ref([])
    const selectedGroupUserIds = ref([])
    const bulkList = ref(null)
    const applyingBulk = ref(false)
    const bulkComment = ref(null)
    const applyingBulkComment = ref(false)
    const bulkPaymentStatus = ref(null)
    const applyingBulkPayment = ref(false)

    watch(() => props.activeList, () => {
      selectedGroupUserIds.value = []
      paymentFilter.value = 'all'
    })

    watch(paymentFilter, () => {
      selectedGroupUserIds.value = []
    })

    watch(() => props.nominations, () => {
      const currentIds = props.nominations.map(g => g.user.id)
      selectedGroupUserIds.value = selectedGroupUserIds.value.filter(id => currentIds.indexOf(id) !== -1)
    })

    function toggleSelect(userId) {
      const idx = selectedGroupUserIds.value.indexOf(userId)
      if (idx === -1) {
        selectedGroupUserIds.value = [...selectedGroupUserIds.value, userId]
      } else {
        selectedGroupUserIds.value = selectedGroupUserIds.value.filter(id => id !== userId)
      }
    }

    function toggleSelectAll() {
      if (selectedGroupUserIds.value.length === filteredNominations.value.length) {
        selectedGroupUserIds.value = []
      } else {
        selectedGroupUserIds.value = filteredNominations.value.map(g => g.user.id)
      }
    }

    // Monolith parity: moving noms to accepted requires confirmation when the
    // draft is in Finalise (invoices are sent immediately) or Closed with
    // generated draws (the nomination will not be added to the draw).
    const pendingMove = ref(null)

    const drawExists = ref(false)
    watch(() => props.draftId, async (id) => {
      drawExists.value = false
      if (id == null) return
      try {
        const res = await nominationsApi.draft(id)
        const data = res.data.data
        drawExists.value = data != null ? !!data.draw_exists : false
      } catch (_) { // handled by http interceptor
      }
    }, { immediate: true })

    function handleBulkMoveError(err, rowUserId = null) {
      const data = err.response != null ? err.response.data : null
      // Structured "already accepted into an overlapping draft" list — render it as its own
      // panel (each name gets a search action) instead of a flat, auto-dismissing alert.
      if (data != null && Array.isArray(data.blocked) && data.blocked.length > 0) {
        blockedAccept.value = data.blocked
        bulkAlert.clear()
        return
      }
      blockedAccept.value = []
      const msg = data != null && data.message != null
        ? data.message
        : 'A server error occurred. Please try again later.'
      notifyRow(rowUserId, msg, 'warning', { persistent: true })
    }

    async function doMoveGroup(group, list) {
      const ids = group.nominations.map(n => n.id)
      const successAnchor = neighbourUserId(group.user.id)
      try {
        const res = await nominationsApi.bulkMove({ nomination_ids: ids, list })
        blockedAccept.value = []
        notifyRow(successAnchor, res.data.message, 'success')
        emit('reload')
      } catch (err) {
        handleBulkMoveError(err, group.user.id)
      }
    }

    async function handleMoveGroup(group, list) {
      const fromList = group.list != null ? group.list : props.activeList
      const warning = moveWarningType(fromList, list, props.draftStateId, drawExists.value)
      if (warning != null) {
        pendingMove.value = { type: 'group', group, list, warning }
        return
      }
      await doMoveGroup(group, list)
    }

    async function doApplyBulkStatus() {
      const ids = props.nominations
        .filter(g => selectedGroupUserIds.value.indexOf(g.user.id) !== -1)
        .reduce((acc, g) => acc.concat(g.nominations.map(n => n.id)), [])
      applyingBulk.value = true
      try {
        const res = await nominationsApi.bulkMove({ nomination_ids: ids, list: bulkList.value.value })
        blockedAccept.value = []
        bulkAlert.showSuccess(res.data.message)
        bulkList.value = null
        emit('reload')
      } catch (err) {
        handleBulkMoveError(err)
      } finally {
        applyingBulk.value = false
      }
    }

    function applyBulkStatus() {
      if (bulkList.value == null || selectedGroupUserIds.value.length === 0) return
      const warning = moveWarningType(props.activeList, bulkList.value.value, props.draftStateId, drawExists.value)
      if (warning != null) {
        pendingMove.value = { type: 'bulk', warning }
        return
      }
      doApplyBulkStatus()
    }

    async function confirmPendingMove() {
      const pending = pendingMove.value
      pendingMove.value = null
      if (pending == null) return
      if (pending.type === 'bulk') {
        await doApplyBulkStatus()
      } else {
        await doMoveGroup(pending.group, pending.list)
      }
    }

    async function onRowCommitChange(row, commit) {
      const ids = row.nominations.map(n => n.id)
      try {
        const res = await nominationsApi.updateCommit(props.draftId, { ids, commit })
        notifyRow(row.user.id, res.data.message, 'success')
        emit('reload')
      } catch (err) {
        tableErrorKey.value++
        const msg = err.response != null && err.response.data != null && err.response.data.message != null
          ? err.response.data.message
          : 'A server error occurred. Please try again later.'
        notifyRow(row.user.id, msg, 'warning')
      }
    }

    async function applyBulkComment() {
      if (bulkComment.value == null || selectedGroupUserIds.value.length === 0) return
      const ids = props.nominations
        .filter(g => selectedGroupUserIds.value.indexOf(g.user.id) !== -1)
        .reduce((acc, g) => acc.concat(g.nominations.map(n => n.id)), [])
      applyingBulkComment.value = true
      try {
        const res = await nominationsApi.updateCommit(props.draftId, { ids, commit: bulkComment.value.value })
        bulkAlert.showSuccess(res.data.message)
        bulkComment.value = null
        emit('reload')
      } catch (err) {
        const msg = err.response != null && err.response.data != null && err.response.data.message != null
          ? err.response.data.message
          : 'A server error occurred. Please try again later.'
        bulkAlert.showError(msg)
      } finally {
        applyingBulkComment.value = false
      }
    }

    async function onRowPaymentStatusChange(row, isPaid) {
      const items = row.nominations.map(n => ({ id: n.id, is_paid: isPaid }))
      try {
        const res = await nominationsApi.updatePaymentStatus(props.draftId, { items })
        notifyRow(row.user.id, res.data.message, 'success')
        emit('reload')
      } catch (err) {
        tableErrorKey.value++
        const msg = err.response != null && err.response.data != null && err.response.data.message != null
          ? err.response.data.message
          : 'A server error occurred. Please try again later.'
        notifyRow(row.user.id, msg, 'warning')
      }
    }

    async function applyBulkPaymentStatus() {
      if (bulkPaymentStatus.value == null || selectedGroupUserIds.value.length === 0) return
      const items = props.nominations
        .filter(g => selectedGroupUserIds.value.indexOf(g.user.id) !== -1)
        .reduce((acc, g) => acc.concat(g.nominations.map(n => ({ id: n.id, is_paid: bulkPaymentStatus.value.value }))), [])
      applyingBulkPayment.value = true
      try {
        const res = await nominationsApi.updatePaymentStatus(props.draftId, { items })
        bulkAlert.showSuccess(res.data.message)
        bulkPaymentStatus.value = null
        emit('reload')
      } catch (err) {
        const msg = err.response != null && err.response.data != null && err.response.data.message != null
          ? err.response.data.message
          : 'A server error occurred. Please try again later.'
        bulkAlert.showError(msg)
      } finally {
        applyingBulkPayment.value = false
      }
    }

    function onListChange(list) {
      bulkAlert.clear()
      rowAlert.clear()
      blockedAccept.value = []
      emit('list-change', list)
    }

    function searchBlocked(competitor) {
      // Populate the nominations search with this competitor's name so the secretary
      // can jump straight to their row and move them off the accept list.
      emit('search-input', competitor.name)
    }

    function dismissBlockedAccept() {
      blockedAccept.value = []
    }

    const downloadingBiosecurityPdf = ref(false)
    const downloadingBiosecurityCsv = ref(false)
    const downloadingVehiclesPdf = ref(false)

    function triggerDownload(res, fallbackName) {
      const disposition = res.headers['content-disposition']
      let filename = fallbackName
      if (disposition) {
        const match = disposition.match(/filename="?([^"]+)"?/)
        if (match) filename = match[1]
      }
      const url = URL.createObjectURL(new Blob([res.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    }

    async function downloadBiosecurityReport(format) {
      const loading = format === 'pdf' ? downloadingBiosecurityPdf : downloadingBiosecurityCsv
      loading.value = true
      try {
        const res = await biosecurityApi.downloadReport(props.draftId, format)
        if (format === 'pdf') {
          const blobUrl = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }))
          window.open(blobUrl, '_blank')
        } else {
          triggerDownload(res, `biosecurity-report.${format}`)
        }
      } catch (_) { // handled by http interceptor
      } finally {
        loading.value = false
      }
    }

    async function downloadVehiclesReport() {
      downloadingVehiclesPdf.value = true
      try {
        const res = await reportsApi.downloadVehiclesPdf(props.draftId)
        const blobUrl = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }))
        window.open(blobUrl, '_blank')
      } catch (_) { // handled by http interceptor
      } finally {
        downloadingVehiclesPdf.value = false
      }
    }

    const sendingReminders = ref(false)

    async function sendOverdueReminders() {
      sendingReminders.value = true
      try {
        const res = await invoicesApi.remind(props.draftId)
        bulkAlert.showSuccess(res.data != null && res.data.message != null ? res.data.message : 'Reminders queued')
      } catch (err) {
        const msg = err.response != null && err.response.data != null && err.response.data.message != null
          ? err.response.data.message
          : 'A server error occurred. Please try again later.'
        bulkAlert.showError(msg)
      } finally {
        sendingReminders.value = false
      }
    }

    const showResendModal = ref(false)
    const resendEventIds = ref([])
    const sendingResend = ref(false)

    async function submitResend() {
      sendingResend.value = true
      try {
        const res = await drawsApi.resendNotifications(props.draftId, {
          events_id: resendEventIds.value,
          members_id: []
        })
        bulkAlert.showSuccess(res.data != null && res.data.message != null ? res.data.message : 'Notifications queued')
        showResendModal.value = false
        resendEventIds.value = []
      } catch (err) {
        const msg = err.response != null && err.response.data != null && err.response.data.message != null
          ? err.response.data.message
          : 'A server error occurred. Please try again later.'
        bulkAlert.showError(msg)
      } finally {
        sendingResend.value = false
      }
    }

    return {
      bulkAlert,
      rowAlert,
      onPartialPaymentSuccess,
      blockedAccept,
      searchBlocked,
      dismissBlockedAccept,
      moveableLists,
      isLocked,
      paymentFilter,
      paymentFilterOptions,
      filteredNominations,
      paymentStatusOptions,
      commitOptions,
      selectedGroupUserIds,
      bulkList,
      applyingBulk,
      bulkComment,
      applyingBulkComment,
      applyBulkComment,
      onRowCommitChange,
      bulkPaymentStatus,
      applyingBulkPayment,
      applyBulkPaymentStatus,
      onRowPaymentStatusChange,
      tableErrorKey,
      handleMoveGroup,
      toggleSelect,
      toggleSelectAll,
      applyBulkStatus,
      pendingMove,
      confirmPendingMove,
      drawExists,
      acceptInvoiceWarning: ACCEPT_INVOICE_WARNING,
      closedDrawWarning: CLOSED_DRAW_WARNING,
      onListChange,
      partialPaymentTarget,
      onOpenPartialPayment,
      closePartialPayment,
      markPartialPaymentChanged,
      detailTarget,
      detailHasChanges,
      markDetailChanged,
      onOpenDetail,
      closeDetail,
      downloadingBiosecurityPdf,
      downloadingBiosecurityCsv,
      downloadingVehiclesPdf,
      downloadBiosecurityReport,
      downloadVehiclesReport,
      sendingReminders,
      sendOverdueReminders,
      showResendModal,
      resendEventIds,
      sendingResend,
      submitResend
    }
  }
})
</script>

<style scoped>
.bulk-action-group__label {
  display: block;
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.bulk-action-group__select {
  min-width: 160px;
}

.nominations-section__event-name {
  font-size: 2rem;
  font-weight: 600;
}

.blocked-accept {
  position: relative;
}

.blocked-accept__close {
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
}

.blocked-accept__row {
  display: flex;
  align-items: center;
  padding: 0.15rem 0;
}

.blocked-accept__search {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 24px;
  height: 24px;
  margin-right: 0.5rem;
  padding: 0;
  border: 1px solid currentColor;
  border-radius: 4px;
  background: transparent;
  color: inherit;
  cursor: pointer;
  opacity: 0.75;
}

.blocked-accept__search:hover {
  opacity: 1;
}

.blocked-accept__name {
  line-height: 1.3;
}

@media only screen and (max-width: 600px) {

  .action-buttons {
    flex-direction: column;
  }

  .action-buttons__right {
    margin-top: 1rem;
  }

  .action-buttons__right .justify-content-end {
    justify-content: flex-start !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Committees/Dashboard/components/CommitteeDashboardNominations.vue